import type { ReactNode } from 'react';
import { useAuthStore } from '../../store/authStore';
import { useTranslation } from 'react-i18next';

interface AuthGuardProps {
  children: ReactNode;
  onLoginRequired: () => void;
}

export function AuthGuard({ children, onLoginRequired }: AuthGuardProps) {
  const { user, loading } = useAuthStore();
  const { t } = useTranslation('common');

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="w-8 h-8 border-2 border-mafia-accent border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="flex flex-col items-center justify-center py-20 gap-4 text-center">
        <p className="text-gray-300 text-lg">{t('auth.loginRequired')}</p>
        <button
          onClick={onLoginRequired}
          className="bg-mafia-accent text-white px-6 py-3 rounded-xl font-medium hover:bg-red-600 transition-colors"
        >
          {t('nav.signIn')}
        </button>
      </div>
    );
  }

  return <>{children}</>;
}
